import { createSelector } from 'reselect'

const getShowRaids = state => state.filter.showRaids;
const getGyms = state => state.marker.gyms;
const getRaidLevel1 = state => state.filter.raidLevel1;
const getRaidLevel2 = state => state.filter.raidLevel2;
const getRaidLevel3 = state => state.filter.raidLevel3;
const getRaidLevel4 = state => state.filter.raidLevel4;
const getRaidLevel5 = state => state.filter.raidLevel5;
const getRaidLevel6 = state => state.filter.raidLevel6;
const getRaidExFilter = state => state.filter.raidExFilter;
const getBounds = state => state.map.mapBounds;
const getHidden = state => state.marker.hidden;

export const selectVisibleRaids = createSelector(
	[getShowRaids, getBounds, getGyms, getRaidLevel1, getRaidLevel2, getRaidLevel3, getRaidLevel4, getRaidLevel5, getRaidLevel6, getRaidExFilter, getHidden],
	(showRaids, bounds, gyms, level1, level2, level3, level4, level5, level6, exFilter, hidden) => {
		if( !showRaids )
			return [];

		let list = Object.values(gyms).filter(gym => gym.level > 0);

		list = list.filter(raid =>
			raid.latitude  < bounds[0][0] && raid.latitude  > bounds[1][0] &&
			raid.longitude < bounds[0][1] && raid.longitude > bounds[1][1]
		);

		if( !level1 )
			list = list.filter(raid => raid.level !== 1);

		if( !level2 )
			list = list.filter(raid => raid.level !== 2);

		if( !level3 )
			list = list.filter(raid => raid.level !== 3);

		if( !level4 )
			list = list.filter(raid => raid.level !== 4);

		if( !level5 )
			list = list.filter(raid => raid.level !== 5);

		if( !level6 )
			list = list.filter(raid => raid.level !== 6);

		if( exFilter )
			list = list.filter(raid => raid.park);

		if( Object.entries(hidden).length )
			list = list.filter(raid => !hidden['raid-' + raid.gym_id + raid.start]);

		return list;
	}
);
